<template>
	<div class="">
		<Header></Header>
		<div class="serchList">
           
	        <div>
                <van-search
                v-model="value"
                placeholder="请输入搜索关键词"
                >
                </van-search>
            </div>
            <div>
                <van-button @click="articleLists" type="info" size='small'>搜索</van-button>
            </div>
		</div>
        <div>
          
            <van-cell-group>
               <van-cell :title="item.title" v-for="item in articleList" :key='item.id' @click="openlist(item.id)" />
             </van-cell-group>
            <div class="notlist"> 
                <p v-show="notinfo">暂无相关文章</p>
            </div>
        </div>
		<Fotter></Fotter>
	</div>
</template>
<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';
	export default {
		name: 'serchList',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
                 notinfo:false,
                 articleList:[],
                 value:'',
			}
		},
		methods: {
            onChange(e) {
                console.log(e)
                // this.setData({
                //     value: e.detail
                // });
            },
         
		
			articleLists(){
				 this.$toast.loading({
					duration: 0,  
					mask: true,
					message: '加载中...'
				});
                  var that = this;
			      this.$axios.get(__Config.api.getsearch,{
					params: {
						articleName:this.value,
					}
				})
				.then(function (res) {
					 that.$toast.clear();
                     that.articleList = res.data.data;
                     if (res.data.data=="") {
                        that.notinfo = true;
                     }
				})
				.catch(function (err) {
					 that.$toast.clear();
					console.log(err);
				});
			},
		
			openlist(id){
               this.$router.push({  
					name:"ZhaokaoMoreDetail" , 
					params: {   
						id: id,   
					}   
				}) 
			},
		},
		created(){
          
		}
	}
</script>

<style scoped>
.serchList{
    width: 98%;
    height: 50px;
    display: flex;
}
.serchList div:nth-child(1){
    flex: 1;
}

.serchList div:nth-child(2){
    width: 60px;
  
        margin-top: 8px;
}
.notlist{
    width: 100%;
    height: 30px;
    }
    .notlist p{
        text-align: center;
        line-height: 30px;
        color: red;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/serchList.vue